<template>
  <div v-show="visible">
    <div class="popup_wrap nodeMarkSetting">
      <div class="popup_title">
        <p><span id="node_title">노드표시설정</span> <span class="node_stitle">※ 실험입력 테이블에 표시할 노드는 파란색으로 표시됩니다.</span></p>
        <a class="_command[CmmComm.closeLayer]">
          <div id="popup_close" class="btn_close" title="Close" @click="close">
            <div class="btn_close_box"><span></span><span></span></div>
          </div>
        </a>
      </div><!-- //popup_title -->
      <div class="popup_content1">
        <div class="node_Marking_wrap">

          <!-- node Marking title -->
          <!--<div class="node_Marking_header">
            <h4 class="node_Marking_tit">노드 목록</h4>
            <div class="node_Marking_stit">※ 테이블에 표시할 노드는 파란색으로 표시됩니다.</div>
          </div>-->

          <!-- node Marking btnarea -->
          <div class="marking_top">
            <div class="marking_top_left">
              <a class="tool_box tool_up" title="순서 올리기"></a>
              <a class="tool_box tool_down" title="순서 내리기"></a>
            </div>
            <div class="marking_top_right">
              <button class="btn_basic" title="편집하기">편집하기</button>
              <button class="btn_basic" title="저장하기">저장하기</button>
            </div>
          </div>

            <!-- node Marking list -->
            <ul class="node_marking_list">
                <li v-for="(node,idx) in nodeArray" :key="idx"
                    :class="{ 'on' : selectedNodeArray.includes(node.tagKey) }">
                    <div class="marking_nodetitle_wrap">
                        <a class="marking_nodetitle" @click="nodeClick(node.tagKey)">{{node.nodeOrder}}. {{node.text}}</a>
                        <div class="marking_fold_area">
                            <button class="node_fold node_fold_down" v-b-toggle="`edit-attr-process-collapse-${idx}`" title="펼치기">&nbsp;</button>
                            <button class="node_fold node_fold_up" v-b-toggle="`edit-attr-process-collapse-${idx}`" title="접기">&nbsp;</button>
                        </div>
                    </div>
                    <!--                <li class="on"><a href="">4.테스트공정</a></li>
                                <li class="nothing"><a href="">5.골드</a></li>-->
                    <!--                    <ul class="nm_inner_list">
                                          <li class="on">
                                            <p>sub 속성1</p>
                                            <div class="tool_wrap">
                                              <a class="tool_box tool_up" title="순서 올리기"></a>
                                              <a class="tool_box tool_down" title="순서 내리기"></a>
                                            </div>
                                          </li>
                                          <li>
                                            <p>sub 속성2</p>
                                            <div class="tool_wrap">
                                              <a class="tool_box tool_up" title="순서 올리기"></a>
                                              <a class="tool_box tool_down" title="순서 내리기"></a>
                                            </div>
                                          </li>
                                        </ul>-->
                    <b-collapse :id="`edit-attr-process-collapse-${idx}`" style="cursor:default">
                        <div style="" @click.stop>
                            <!--                    <p style="white-space: pre-line; text-align: left;font-size: 13px; font-weight: bold">{{ prop.propertyDefine }}</p>-->
                            <ul class="nm_inner_list">
                                <li class="on">
                                    <a class="nm_title">sub 속성1</a>
                                    <div class="tool_wrap">
                                        <a class="tool_box tool_up" title="순서 올리기"></a>
                                        <a class="tool_box tool_down" title="순서 내리기"></a>
                                    </div>
                                </li>
                                <li>
                                    <a class="nm_title">sub 속성2</a>
                                    <div class="tool_wrap">
                                        <a class="tool_box tool_up" title="순서 올리기"></a>
                                        <a class="tool_box tool_down" title="순서 내리기"></a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </b-collapse>

                </li>
            </ul>

        </div>
      </div>
      <div class="popup_footer">
        <a class="btn_type1">저장</a>
        <a class="btn_type3" @click="close">닫기</a>
      </div>
    </div>
    <div class="mask_wrap" style="display:block;"></div>
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
import Loading from '@common/loading.vue';
import CommNew from "@processEditor/CommNew";
import {createNamespacedHelpers} from 'vuex';
const Hub = createNamespacedHelpers('Hub');

export default {
  mixins:[CommNew],
  components: {
    Loading,
  },
  data() {
    return {
      loading : null,
      visible : false,
      nodeArray : [],
      selectedNodeArray : [],
      resetDataKey : ["nodeArray"],
    }
  },
  computed : {
    ...Hub.mapGetters(['hotInstance','getNodeMarkSettingPopFlag']),
  } ,
  watch: {
      getNodeMarkSettingPopFlag: {
				// deep: true,
				// immediate: true,
				async handler (value) {
					if(value === true){
            this.show();
            //this.resetData(this.resetDataKey);
            await this.getProcessDetail();
          }
				}
			},
    nodeArray:{
      deep: true,
      async handler (value) {
			  console.log('nodeArray',value);
      }
    }
  },
  async mounted() {
  },
  methods: {
    ...Hub.mapMutations(
        [
          "setNodeMarkSettingPopFlag",
        ]
    ),
    nodeClick(tagkey){
      const selectedNode = this.nodeArray.find(node => {return node.tagKey == tagkey});
      if(!this.selectedNodeArray.includes(selectedNode.tagKey)){
       this.selectedNodeArray.push(selectedNode.tagKey);
      }else{
        this.selectedNodeArray = this.selectedNodeArray.filter(activeTagkey => {return activeTagkey != tagkey})
      }
    },
    async getProcessDetail() {
      this.loading = true
      try {
        let response = await this.$wApi.process.detail(null, this.PROCESS_INFO.processId)
        const data = JSON.parse(response.json)

        let nodes = data.nodes.sort((a, b) => a.nodeOrder - b.nodeOrder);
        this.nodeArray = [];
        nodes.forEach(node => {
          this.nodeArray.push(node);
        });
        this.loading = false
      } catch (error) {
        this.loading = false
      }
      this.loading = false
    },
    resetData(keyArr){
      keyArr.forEach(key => {
        this[key] = [];
      });
    },
    show() {
      this.visible = true;
    },
    close() {
      this.setNodeMarkSettingPopFlag(false);
      this.visible = false;
    },
  }
}
</script>

<style lang="scss">
@import "@/style/new/css/cyl.common.css";
.nodeMarkSetting {display:block;position:fixed; width:600px;height:85%;  left:50%;top:50%;transform:translate(-50%,-50%); z-index:999; box-shadow:5px 5px 20px 0px rgba(0,0,0,0.2);}
</style>